import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

// Container for the whole section
const Section = styled.div`
  ${tw`flex flex-col md:flex-row rounded-none overflow-hidden bg-[#000000]`}
  width: 100vw;
  min-width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
  min-height: 220px;
`;

// Image container
const ImageContainer = styled.div`
  ${tw`w-full md:w-1/2 flex items-center justify-center`}
  background: #e3d6c8;
  min-height: 220px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

// Content container
const Content = styled.div`
  ${tw`w-full md:w-1/2 flex flex-col justify-center items-center p-8`}
  background: #000000;
  text-align: center;
`;

// Title
const Title = styled.h2`
  ${tw`text-xl md:text-2xl font-bold mb-4`}
  color: #FFF;
`;

// Description
const Description = styled.p`
  ${tw`mb-6`}
  font-size: 1rem;
    color: #FFF;

`;

// Outlined Button
const OutlinedButton = styled.button`
  ${tw`px-6 py-2 rounded border border-gray-700 font-medium`}
  background: #FFFFFF;
  color: #000000;
  transition: background 0.2s, color 0.2s;
  &:hover {
  background: #FFFFFF;
    color: #000000;
  }
`;

const ForceOfNatureSection = ({
  imageSrc,
  title = "LA NATURE À VOTRE SERVICE",
  description = "Découvrez notre large gamme de produits naturels pensés pour accompagner votre bien-être au quotidien. Des soins capillaires et corporels aux compléments alimentaires et essentiels nutritionnels, nous vous offrons un large choix pour chaque besoin.",
  buttonText = "Découvrez nos produits",
  onButtonClick,
}) => (
  <Section>
    <ImageContainer>
      <img src={imageSrc} alt={title} />
    </ImageContainer>
    <Content>
      <Title>{title}</Title>
      <Description>{description}</Description>
      <OutlinedButton onClick={onButtonClick}>{buttonText}</OutlinedButton>
    </Content>
  </Section>
);

export default ForceOfNatureSection;